import React from 'react';
import './app.css';
import { hydrateRoot, createRoot } from 'react-dom/client';
import { HydrationBoundary, QueryClient, QueryClientProvider } from '@tanstack/react-query';
import type { DehydratedState } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App.js';
import { AppUpdates } from './components/app-updates.js';

const queryClient = new QueryClient({ defaultOptions: { queries: { staleTime: 30_000, retry: 1, refetchOnWindowFocus: false } } });
let initialState: DehydratedState | undefined;
try {
  const stateScript = document.getElementById('__REACT_QUERY_STATE__');
  if (stateScript?.textContent) initialState = JSON.parse(stateScript.textContent) as DehydratedState;
} catch { initialState = undefined; }
const tree = <React.StrictMode><QueryClientProvider client={queryClient}><HydrationBoundary state={initialState}><BrowserRouter><App /><AppUpdates /></BrowserRouter></HydrationBoundary></QueryClientProvider></React.StrictMode>;
const root = document.getElementById('root');
if (root) {
  if (root.children.length > 0) hydrateRoot(root, tree);
  else createRoot(root).render(tree);
}

